import { lazyWithRetry } from '@lon/shared/utils';

const QrCode = lazyWithRetry(() => import('./QrCode'), 'QrCode');

export { QrCode };
